var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowComponents())?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_IS_AVAILABLE_IMPORT_POTENTIAL'
      )
    }},[_c('p',{staticClass:"content-s-2-label"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
            _vm.$parent.project.SETTING_TABLE.allData
              .UF_IS_AVAILABLE_IMPORT_POTENTIAL
          ),expression:"\n            $parent.project.SETTING_TABLE.allData\n              .UF_IS_AVAILABLE_IMPORT_POTENTIAL\n          "}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(
            _vm.$parent.project.SETTING_TABLE.allData
              .UF_IS_AVAILABLE_IMPORT_POTENTIAL
          )?_vm._i(
            _vm.$parent.project.SETTING_TABLE.allData
              .UF_IS_AVAILABLE_IMPORT_POTENTIAL
          ,null)>-1:(
            _vm.$parent.project.SETTING_TABLE.allData
              .UF_IS_AVAILABLE_IMPORT_POTENTIAL
          )},on:{"change":function($event){var $$a=
            _vm.$parent.project.SETTING_TABLE.allData
              .UF_IS_AVAILABLE_IMPORT_POTENTIAL
          ,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$parent.project.SETTING_TABLE.allData
              , "UF_IS_AVAILABLE_IMPORT_POTENTIAL", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$parent.project.SETTING_TABLE.allData
              , "UF_IS_AVAILABLE_IMPORT_POTENTIAL", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$parent.project.SETTING_TABLE.allData
              , "UF_IS_AVAILABLE_IMPORT_POTENTIAL", $$c)}}}}),_vm._v("\n        Наличие потенциала импортозамещения\n      ")])]),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText(
          "PROJECTS",
          "LOGIC",
          "UF_IS_AVAILABLE_IMPORT_POTENTIAL"
        ))+"\n    ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }